import { jsonInstance } from './Api';

class ApiService {
  // -------------------------
  // Campaign APIs
  // -------------------------

  startCampaign(campaignId, data) {
    return jsonInstance.put(`/campaign/start/${campaignId}`, data);
  }

  stopCampaign(campaignId, data) {
    return jsonInstance.put(`/campaign/stop/${campaignId}`, data);
  }

  getCampaignSignedUrl(params) {
    return jsonInstance.get("/campaign/signed-url", { params });
  }

  uploadCampaignLead(data) {
    return jsonInstance.post("/campaign/upload-lead", data);
  }

  getCampaignList(params) {
    return jsonInstance.get("/campaign/list", { params });
  }

  getCampaignSampleHeader(params) {
    return jsonInstance.get("/campaign/sample-header", { params });
  }

  getSignedUrl(data) {
    return jsonInstance.post("/campaign/signed-url",data);
  }
    uploadLead(data) {
    return jsonInstance.post("/campaign/upload-lead",data);
  }
   getLeadList(data,params) {
    return jsonInstance.post("/campaign/lead-list",data,{ params });
  }
  getAllCallList(data,params) {
    return jsonInstance.post("/campaign/calls",data,{ params });
  }
 getLeadDetailsById(lead_id) {
    return jsonInstance.get(`/campaign/lead-detail/${lead_id}`);
  }
  getRecordingJobs(data,params) {
    return jsonInstance.get(`/campaign/get-recording-job`,data,{ params });
  }
  createRecordingJob(data) {
    return jsonInstance.post(`/campaign/create-recording-job`,data);
  }
  getRecordingDownloadUrl(job_id) {
    return jsonInstance.get(`/campaign/recording-url/${job_id}`);
  } 

  // -------------------------
  // Options APIs
  // -------------------------

  getCampaignStatusOptions(params) {
    return jsonInstance.get("/option/campaign-status", { params });
  }
   getCampaignOptions(data) {
    return jsonInstance.get("/option/campaigns",data);
  }
   getDispositionOptions(data) {
    return jsonInstance.get("/option/disposition",data);
  }
    getDurationOptions(data) {
    return jsonInstance.post("/option/durations",data);
  }
    getCallStatusOptions(data) {
    return jsonInstance.get("/option/call-status",data);
  }

  getIvrOptions(data) {
    return jsonInstance.post("/option/ivr-options",data);
  }
  getLanguageOptions(data){
    return jsonInstance.get("/option/lang-options",data);
  }
   getDispositionListOptions(data){
    return jsonInstance.get("/option/disposition-list",data);
  }
   getSubDispositionOptions(data){
    return jsonInstance.get("/option/sub-disposition",{ params: data });
  }
  getCampaignPresetOptions(data){
    return jsonInstance.get("/option/campaign-presets",data);
  }
  getPreProcessingOptions(data){
    return jsonInstance.get("/option/pre-processing",data);
  }
   getReportTypeOptions(data){
    return jsonInstance.get("/option/reports",data);
  }
   getScriptOptions(data){
    return jsonInstance.get("/option/scripts", { params: data });
  }
  
  
   getBatchesOptions(id){
    return jsonInstance.get(`/campaign/available-batches/${id}`);
  }
  getRecordingSignedUrl(callId) {
  return jsonInstance.get(`/campaign/calls-record/${callId}`);
}
 getCallbackLeadCount(data) {
    return jsonInstance.post(`/campaign/rechurn-count`,data);
  } 
  updateLeadCallback(data) {
    return jsonInstance.post(`/campaign/rechurn`,data);
  } 
   updateCallEndDisposition(data) {
    return jsonInstance.post(`/update-call-end-disposition`,data);
  } 
  getReports(data) {
    return jsonInstance.post(`/report`,data);
  } 
  
}

export default new ApiService();
